import React, { useEffect } from 'react'
import { Box } from '@node-space/ui-components'
import { ContactsSheets } from 'pages/Contacts/components/ContactsSheets'
import { ContactAtomType } from 'types/atoms/atom.contacts'
import { ChannelPaymentStep } from 'types/payments'
import { ContactsSearch } from '../../../components/Contacts/ContactsSearch'
import { usePaymentFlow } from '../hooks/usePaymentFlow'
import { channelPaymentStepAtom } from './atoms/atoms'
import { ChannelPaymentComplete } from './ChannelPaymentComplete'
import { ChannelPaymentDetails } from './ChannelPaymentDetails'

const channelPaymentSteps = [
  ChannelPaymentStep.CONTACT,
  ChannelPaymentStep.DETAILS,
  ChannelPaymentStep.COMPLETE,
] as const

export const ChannelPayment = () => {
  const { currentStep, isContactSheetOpen, updateWalletAction } = usePaymentFlow({
    stepAtom: channelPaymentStepAtom,
    steps: channelPaymentSteps,
    stepConfig: ChannelPaymentStep,
    translationKeys: {
      contactStepHeader: 'payments.channelPayments.contactStepHeader',
      detailsStepHeader: 'payments.channelPayments.detailsStepHeader',
      requiredFieldsCallout: 'contacts.channelPaymentRequiredAdditionalContactDetails',
    },
  })

  useEffect(() => {
    updateWalletAction()
  }, [currentStep])

  return (
    <Box width="full">
      {currentStep === ChannelPaymentStep.CONTACT && (
        <ContactsSearch atomType={ContactAtomType.WALLET_ACTION} />
      )}
      {currentStep === ChannelPaymentStep.DETAILS && <ChannelPaymentDetails />}
      {currentStep === ChannelPaymentStep.COMPLETE && <ChannelPaymentComplete />}
      <ContactsSheets isSheetOpen={isContactSheetOpen} isNestedSheet={true} />
    </Box>
  )
}
